import { Link, useParams } from "react-router-dom";

import useStyles from "./checkout-links.styles";

const CheckoutLinks = ({ checkoutRoutes }: { checkoutRoutes: string[] }) => {
  const classes = useStyles();

  const { checkoutProcessPath }: { checkoutProcessPath: string } = useParams();

  const currentRouteIndex = checkoutRoutes.findIndex(
    (route) => route === checkoutProcessPath,
  );

  return (
    <div className={classes.links}>
      {checkoutRoutes.map((route, index) => (
        <Link
          key={index}
          to={`/checkout/${route}`}
          className={`${
            index <= currentRouteIndex
              ? classes.processedLink
              : classes.unprocessedLink
          }`}
        >
          {route}
        </Link>
      ))}
    </div>
  );
};

export default CheckoutLinks;
